const config = {
  //BASE_URL: "http://127.0.0.1:8000/",
  BASE_URL: "https://ekrak.com/",
  OUTSIDE_URL: "http://localhost/justnowapp/public/various/",
  STORAGE_CX_STATE: "@cxState",
}

export default config
